import { useEffect, useState } from 'react'
import BottomSheetContent from '../../../../../../../components/BottomSheetComponents/BottomSheetContent'
import { PrimaryButton } from '../../../../../../../components/execution/PrimaryButton'
import { EventNames } from '../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../utils/appBridge'
import { PlansBottomSheet, PlansScreen, PlansSipListEventIds } from '../../../../analytics/plansEvents'
import { SipEditIdealSipAmountInput, SIP_EDIT_IDEAL_MAX_MONTHLY_AMOUNT } from './SipEditIdealSipAmountInput'

type SipEditIdealSipBottomSheetProps = {
  initialAmount: number
  minSipValue: number
  maxSipValue: number
  onDismiss: () => void
  onConfirm: (totalIdealSipAmount: number) => void
}

export function SipEditIdealSipBottomSheet({
  initialAmount,
  minSipValue,
  maxSipValue,
  onDismiss,
  onConfirm
}: SipEditIdealSipBottomSheetProps) {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        ScreenName: PlansScreen.SipIdeal,
        eventId: PlansBottomSheet.EditIdealSip,
        bottomSheetName: PlansBottomSheet.EditIdealSip
      }
    })
  }, [])

  const [amount, setAmount] = useState(initialAmount)
  const resolvedMinSipValue = minSipValue > 0 ? minSipValue : 1
  const resolvedMaxSipValue = maxSipValue > 0 ? maxSipValue : SIP_EDIT_IDEAL_MAX_MONTHLY_AMOUNT
  const isConfirmDisabled =
    amount < resolvedMinSipValue || amount > resolvedMaxSipValue

  const handleConfirm = () => {
    if (isConfirmDisabled) return
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: PlansScreen.SipIdeal,
        eventId: PlansSipListEventIds.EditIdealSipConfirm,
        buttonLabel: 'Confirm'
      }
    })
    onConfirm(amount)
  }

  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      heading="Edit SIP amount"
      bottomSheetBodyClassName="!px-0 !pb-0"
      bottomSheetCtas={
        <PrimaryButton
          label="Confirm"
          onClick={handleConfirm}
          isDisabled={isConfirmDisabled}
          primaryButtonClassName="w-full !h-[56px] !font-[500] !rounded-[16px]"
          testLocator="sip-edit-ideal-amount-confirm"
        />
      }
    >
      <div className="px-5">
        <p className="mb-4 text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
          Enter total amount you invest each month as SIPs
        </p>
        <SipEditIdealSipAmountInput
          inputId="sip-edit-ideal-amount"
          label="Monthly Investment"
          value={amount}
          onChange={setAmount}
          onClear={() => setAmount(0)}
          minValue={resolvedMinSipValue}
          maxValue={resolvedMaxSipValue}
          testLocator="sip-edit-ideal-amount"
        />
      </div>
    </BottomSheetContent>
  )
}
